

// import React, { useState } from 'react';
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from 'recharts';

// import html2pdf from 'html2pdf.js';
// import CalculatorForm from './CalculatorForm';
// import { motion } from 'framer-motion';

// import {
//   FaChartLine,
//   FaFilePdf,
//   FaWhatsapp,
//   FaShieldAlt,
// } from 'react-icons/fa';

// const SIPCalculator = () => {
//   const [monthlyInvestment, setMonthlyInvestment] =
//     useState(5000);

//   const [expectedReturn, setExpectedReturn] =
//     useState(12);

//   const [inflationRate, setInflationRate] =
//     useState(6);

//   const [timePeriod, setTimePeriod] =
//     useState(10);

//   const [showForm, setShowForm] =
//     useState(false);

//   const [result, setResult] = useState(null);

//   const [chartData, setChartData] = useState([]);

//   const calculate = () => {
//     const monthlyRate =
//       expectedReturn / 12 / 100;

//     const inflationAdjustedReturn =
//       ((1 + expectedReturn / 100) /
//         (1 + inflationRate / 100) -
//         1) *
//       100;

//     const realMonthlyRate =
//       inflationAdjustedReturn / 12 / 100;

//     const months = timePeriod * 12;

//     // FUTURE VALUE
//     const futureValue =
//       monthlyInvestment *
//       ((Math.pow(1 + monthlyRate, months) - 1) /
//         monthlyRate) *
//       (1 + monthlyRate);

//     // REAL VALUE AFTER INFLATION
//     const inflationAdjustedValue =
//       monthlyInvestment *
//       ((Math.pow(
//         1 + realMonthlyRate,
//         months
//       ) -
//         1) /
//         realMonthlyRate) *
//       (1 + realMonthlyRate);

//     const totalInvestment =
//       monthlyInvestment * months;

//     const estimatedReturns =
//       futureValue - totalInvestment;

//     // CHART DATA
//     const data = [];

//     let runningTotal = 0;

//     let inflationValue = 0;

//     for (let month = 1; month <= months; month++) {
//       runningTotal =
//         (runningTotal + monthlyInvestment) *
//         (1 + monthlyRate);

//       inflationValue =
//         (inflationValue +
//           monthlyInvestment) *
//         (1 + realMonthlyRate);

//       if (month % 12 === 0) {
//         data.push({
//           year: month / 12,
//           investment:
//             monthlyInvestment * month,
//           value: Math.round(runningTotal),
//           inflationAdjusted:
//             Math.round(inflationValue),
//         });
//       }
//     }

//     setResult({
//       futureValue,
//       totalInvestment,
//       estimatedReturns,
//       inflationAdjustedValue,
//     });

//     setChartData(data);
//   };

//   const downloadPDF = () => {
//     setShowForm(true);
//   };

//   const handleFormSubmit = (userData) => {
//     const element = document.getElementById(
//       'sip-result-content'
//     );

//     const opt = {
//       margin: [0.4, 0.4, 0.4, 0.4],
//       filename: `SIP_Report_${userData.name}.pdf`,
//       image: {
//         type: 'jpeg',
//         quality: 1,
//       },
//       html2canvas: {
//         scale: 2,
//       },
//       jsPDF: {
//         unit: 'in',
//         format: 'a4',
//         orientation: 'portrait',
//       },
//     };

//     html2pdf().set(opt).from(element).save();

//     setShowForm(false);

//     // WHATSAPP MESSAGE
//     const whatsappMessage = `
// Dear ${userData.name},

// Thank you for using Wisdom Consultancy SIP Calculator.

// 📊 Investment Summary

// • Monthly SIP: ₹${monthlyInvestment.toLocaleString()}
// • Expected Return: ${expectedReturn}% p.a.
// • Inflation Rate: ${inflationRate}% p.a.
// • Time Period: ${timePeriod} Years

// 💰 Total Investment:
// ₹${result.totalInvestment.toLocaleString()}

// 📈 Estimated Returns:
// ₹${result.estimatedReturns.toLocaleString()}

// 🏆 Future Value:
// ₹${result.futureValue.toLocaleString()}

// 📉 Inflation Adjusted Value:
// ₹${result.inflationAdjustedValue.toLocaleString()}

// For personalized financial guidance contact:

// 📞 +91 9726344477
// 📧 wisdom2secure@gmail.com

// Wisdom Consultancy
// Your Trusted Partner for Wealth & Financial Security
// `;

//     window.open(
//       `https://wa.me/${userData.phone}?text=${encodeURIComponent(
//         whatsappMessage
//       )}`,
//       '_blank'
//     );
//   };

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       className="bg-white rounded-[35px] shadow-xl p-6 md:p-10 border border-[#edf3ff]"
//     >
//       {/* HEADER */}
//       <div className="mb-8">
//         <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-5">
//           <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
//             <FaChartLine />
//           </div>

//           <span className="font-semibold text-[#0b1c39]">
//             Smart SIP Planning
//           </span>
//         </div>

//         <h3 className="text-3xl md:text-4xl font-bold text-[#0b1c39] mb-3">
//           SIP Calculator
//         </h3>

//         <p className="text-gray-600 text-lg leading-8">
//           Calculate your SIP investment growth with
//           inflation-adjusted future value projections.
//         </p>
//       </div>

//       <div className="grid lg:grid-cols-2 gap-10">
//         {/* LEFT SECTION */}
//         <div className="space-y-8">
//           {/* MONTHLY SIP */}
//           <div className="bg-[#f8fbff] rounded-3xl p-6 border border-[#edf3ff]">
//             <label className="block text-[#0b1c39] font-bold mb-4 text-lg">
//               Monthly Investment (₹)
//             </label>

//             <input
//               type="range"
//               min="500"
//               max="100000"
//               step="500"
//               value={monthlyInvestment}
//               onChange={(e) =>
//                 setMonthlyInvestment(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full h-2 rounded-lg appearance-none cursor-pointer bg-[#dce7ff]"
//             />

//             <div className="flex justify-between mt-4">
//               <span className="text-gray-500 text-sm">
//                 ₹500
//               </span>

//               <span className="text-[#2e56b8] font-bold text-xl">
//                 ₹
//                 {monthlyInvestment.toLocaleString()}
//               </span>

//               <span className="text-gray-500 text-sm">
//                 ₹1,00,000
//               </span>
//             </div>
//           </div>

//           {/* RETURN */}
//           <div className="bg-[#f8fbff] rounded-3xl p-6 border border-[#edf3ff]">
//             <label className="block text-[#0b1c39] font-bold mb-4 text-lg">
//               Expected Return (% p.a.)
//             </label>

//             <input
//               type="range"
//               min="1"
//               max="30"
//               step="0.5"
//               value={expectedReturn}
//               onChange={(e) =>
//                 setExpectedReturn(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full h-2 rounded-lg appearance-none cursor-pointer bg-[#dce7ff]"
//             />

//             <div className="flex justify-between mt-4">
//               <span className="text-gray-500 text-sm">
//                 1%
//               </span>

//               <span className="text-[#2e56b8] font-bold text-xl">
//                 {expectedReturn}%
//               </span>

//               <span className="text-gray-500 text-sm">
//                 30%
//               </span>
//             </div>
//           </div>

//           {/* INFLATION */}
//           <div className="bg-[#f8fbff] rounded-3xl p-6 border border-[#edf3ff]">
//             <label className="block text-[#0b1c39] font-bold mb-4 text-lg">
//               Inflation Rate (% Optional)
//             </label>

//             <input
//               type="range"
//               min="0"
//               max="10"
//               step="0.5"
//               value={inflationRate}
//               onChange={(e) =>
//                 setInflationRate(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full h-2 rounded-lg appearance-none cursor-pointer bg-[#dce7ff]"
//             />

//             <div className="flex justify-between mt-4">
//               <span className="text-gray-500 text-sm">
//                 0%
//               </span>

//               <span className="text-[#69bf74] font-bold text-xl">
//                 {inflationRate}%
//               </span>

//               <span className="text-gray-500 text-sm">
//                 10%
//               </span>
//             </div>
//           </div>

//           {/* TIME */}
//           <div className="bg-[#f8fbff] rounded-3xl p-6 border border-[#edf3ff]">
//             <label className="block text-[#0b1c39] font-bold mb-4 text-lg">
//               Time Period (Years)
//             </label>

//             <input
//               type="range"
//               min="1"
//               max="40"
//               value={timePeriod}
//               onChange={(e) =>
//                 setTimePeriod(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full h-2 rounded-lg appearance-none cursor-pointer bg-[#dce7ff]"
//             />

//             <div className="flex justify-between mt-4">
//               <span className="text-gray-500 text-sm">
//                 1 Year
//               </span>

//               <span className="text-[#2e56b8] font-bold text-xl">
//                 {timePeriod} Years
//               </span>

//               <span className="text-gray-500 text-sm">
//                 40 Years
//               </span>
//             </div>
//           </div>

//           {/* BUTTON */}
//           <button
//             onClick={calculate}
//             className="w-full bg-[#2e56b8] hover:bg-[#24479b] text-white py-5 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg"
//           >
//             Calculate SIP Growth
//           </button>
//         </div>

//         {/* RIGHT RESULT */}
//         {result && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             className="bg-gradient-to-br from-[#edf3ff] to-[#eef8f1] rounded-[35px] p-8 border border-[#dce7ff]"
//           >
//             <h4 className="text-3xl font-bold text-[#0b1c39] mb-8">
//               Investment Summary
//             </h4>

//             <div className="space-y-5">
//               <div className="bg-white rounded-2xl p-5 flex justify-between items-center shadow-sm">
//                 <span className="text-gray-600 font-medium">
//                   Total Investment
//                 </span>

//                 <span className="text-[#0b1c39] font-bold text-xl">
//                   ₹
//                   {parseFloat(
//                     result.totalInvestment
//                   ).toLocaleString()}
//                 </span>
//               </div>

//               <div className="bg-white rounded-2xl p-5 flex justify-between items-center shadow-sm">
//                 <span className="text-gray-600 font-medium">
//                   Estimated Returns
//                 </span>

//                 <span className="text-[#69bf74] font-bold text-xl">
//                   + ₹
//                   {parseFloat(
//                     result.estimatedReturns
//                   ).toLocaleString()}
//                 </span>
//               </div>

//               <div className="bg-white rounded-2xl p-5 flex justify-between items-center shadow-sm">
//                 <span className="text-gray-600 font-medium">
//                   Inflation Adjusted Value
//                 </span>

//                 <span className="text-[#2e56b8] font-bold text-xl">
//                   ₹
//                   {parseFloat(
//                     result.inflationAdjustedValue
//                   ).toLocaleString()}
//                 </span>
//               </div>

//               <div className="bg-[#2e56b8] rounded-3xl p-6 text-white mt-5 shadow-xl">
//                 <p className="text-white/80 mb-2">
//                   Total Future Value
//                 </p>

//                 <h2 className="text-4xl font-extrabold">
//                   ₹
//                   {parseFloat(
//                     result.futureValue
//                   ).toLocaleString()}
//                 </h2>
//               </div>
//             </div>

//             {/* DOWNLOAD */}
//             <button
//               onClick={downloadPDF}
//               className="w-full mt-8 bg-[#69bf74] hover:bg-[#58ab63] text-white py-4 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg flex items-center justify-center gap-3"
//             >
//               <FaFilePdf />
//               Download Professional PDF Report
//             </button>
//           </motion.div>
//         )}
//       </div>

//       {/* CHART */}
//       {chartData.length > 0 && (
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           className="mt-14"
//         >
//           <h4 className="text-3xl font-bold text-[#0b1c39] mb-8">
//             Investment Growth Projection
//           </h4>

//           <div className="bg-[#f8fbff] rounded-[35px] p-6 border border-[#edf3ff]">
//             <div className="h-[420px]">
//               <ResponsiveContainer
//                 width="100%"
//                 height="100%"
//               >
//                 <LineChart data={chartData}>
//                   <CartesianGrid strokeDasharray="3 3" />

//                   <XAxis dataKey="year" />

//                   <YAxis />

//                   <Tooltip
//                     formatter={(value) =>
//                       `₹${value.toLocaleString()}`
//                     }
//                   />

//                   <Legend />

//                   <Line
//                     type="monotone"
//                     dataKey="investment"
//                     stroke="#2e56b8"
//                     strokeWidth={3}
//                     name="Total Invested"
//                   />

//                   <Line
//                     type="monotone"
//                     dataKey="value"
//                     stroke="#69bf74"
//                     strokeWidth={3}
//                     name="Portfolio Value"
//                   />

//                   <Line
//                     type="monotone"
//                     dataKey="inflationAdjusted"
//                     stroke="#ff9800"
//                     strokeWidth={3}
//                     name="Inflation Adjusted Value"
//                   />
//                 </LineChart>
//               </ResponsiveContainer>
//             </div>
//           </div>
//         </motion.div>
//       )}

//       {/* PDF CONTENT */}
//       {result && (
//         <div
//           id="sip-result-content"
//           style={{ display: 'none' }}
//         >
//           <div
//             style={{
//               padding: '30px',
//               fontFamily: 'Arial',
//               color: '#222',
//             }}
//           >
//             {/* HEADER */}
//             <div
//               style={{
//                 borderBottom:
//                   '3px solid #2e56b8',
//                 paddingBottom: '20px',
//                 marginBottom: '20px',
//               }}
//             >
//               <h1
//                 style={{
//                   color: '#2e56b8',
//                   marginBottom: '10px',
//                 }}
//               >
//                 Wisdom Consultancy
//               </h1>

//               <p>
//                 E-44, Vasant Vihar Society,
//                 GIDC-Vadsar Road,
//                 Vadodara-390010
//               </p>

//               <p>
//                 Phone: +91 9726344477 |
//                 Email:
//                 wisdom2secure@gmail.com
//               </p>

//               <p>
//                 ARN No: ARN-XXXXX
//               </p>
//             </div>

//             {/* REPORT TITLE */}
//             <h2
//               style={{
//                 textAlign: 'center',
//                 color: '#0b1c39',
//                 marginBottom: '20px',
//               }}
//             >
//               SIP Investment Report
//             </h2>

//             {/* TABLE */}
//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse:
//                   'collapse',
//               }}
//             >
//               <tbody>
//                 {[
//                   [
//                     'Monthly SIP',
//                     `₹${monthlyInvestment.toLocaleString()}`,
//                   ],
//                   [
//                     'Expected Return',
//                     `${expectedReturn}%`,
//                   ],
//                   [
//                     'Inflation Rate',
//                     `${inflationRate}%`,
//                   ],
//                   [
//                     'Time Period',
//                     `${timePeriod} Years`,
//                   ],
//                   [
//                     'Total Investment',
//                     `₹${result.totalInvestment.toLocaleString()}`,
//                   ],
//                   [
//                     'Estimated Returns',
//                     `₹${result.estimatedReturns.toLocaleString()}`,
//                   ],
//                   [
//                     'Future Value',
//                     `₹${result.futureValue.toLocaleString()}`,
//                   ],
//                   [
//                     'Inflation Adjusted Value',
//                     `₹${result.inflationAdjustedValue.toLocaleString()}`,
//                   ],
//                 ].map((row, index) => (
//                   <tr
//                     key={index}
//                     style={{
//                       borderBottom:
//                         '1px solid #ddd',
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: '12px',
//                         fontWeight: 'bold',
//                       }}
//                     >
//                       {row[0]}
//                     </td>

//                     <td
//                       style={{
//                         padding: '12px',
//                       }}
//                     >
//                       {row[1]}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {/* DISCLAIMER */}
//             <div
//               style={{
//                 marginTop: '30px',
//                 background: '#f5f5f5',
//                 padding: '20px',
//                 borderRadius: '10px',
//               }}
//             >
//               <div
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '10px',
//                   marginBottom: '10px',
//                 }}
//               >
//                 <FaShieldAlt />

//                 <strong>
//                   Mutual Fund Disclaimer
//                 </strong>
//               </div>

//               <p
//                 style={{
//                   fontSize: '12px',
//                   lineHeight: '22px',
//                   color: '#555',
//                 }}
//               >
//                 Mutual Fund investments are
//                 subject to market risks.
//                 Please read all scheme
//                 related documents carefully
//                 before investing. Past
//                 performance is not indicative
//                 of future returns.
//               </p>
//             </div>

//             {/* FOOTER */}
//             <div
//               style={{
//                 marginTop: '25px',
//                 textAlign: 'center',
//                 fontSize: '12px',
//                 color: '#777',
//               }}
//             >
//               <p>
//                 This is a computer generated
//                 report by Wisdom Consultancy.
//               </p>

//               <p>
//                 www.wisdomconsultancy.in
//               </p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* FORM */}
//       {showForm && (
//         <CalculatorForm
//           onSubmit={handleFormSubmit}
//           onClose={() =>
//             setShowForm(false)
//           }
//           calculatorType="SIP"
//         />
//       )}
//     </motion.div>
//   );
// };

// export default SIPCalculator;

//////////////////////////////////////////////////////////////////////

// import React, { useState } from 'react';
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   AreaChart,
//   Area,
// } from 'recharts';

// import html2pdf from 'html2pdf.js';
// import CalculatorForm from './CalculatorForm';
// import { motion } from 'framer-motion';

// import {
//   FaChartLine,
//   FaFilePdf,
//   FaShieldAlt,
//   FaCalculator,
//   FaRupeeSign,
//   FaArrowTrendUp,
// } from 'react-icons/fa6';

// const SIPCalculator = () => {
//   const [monthlyInvestment, setMonthlyInvestment] =
//     useState(5000);

//   const [expectedReturn, setExpectedReturn] =
//     useState(12);

//   const [inflationRate, setInflationRate] =
//     useState(6);

//   const [timePeriod, setTimePeriod] =
//     useState(10);

//   const [showForm, setShowForm] =
//     useState(false);

//   const [result, setResult] = useState(null);

//   const [chartData, setChartData] = useState([]);

//   const formatCurrency = (value) => {
//     return Number(value).toLocaleString('en-IN');
//   };

//   const calculate = () => {
//     const monthlyRate =
//       expectedReturn / 12 / 100;

//     const months = timePeriod * 12;

//     const inflationAdjustedReturn =
//       ((1 + expectedReturn / 100) /
//         (1 + inflationRate / 100) -
//         1) *
//       100;

//     const realMonthlyRate =
//       inflationAdjustedReturn / 12 / 100;

//     const futureValue =
//       monthlyInvestment *
//       ((Math.pow(1 + monthlyRate, months) - 1) /
//         monthlyRate) *
//       (1 + monthlyRate);

//     const inflationAdjustedValue =
//       monthlyInvestment *
//       ((Math.pow(
//         1 + realMonthlyRate,
//         months
//       ) -
//         1) /
//         realMonthlyRate) *
//       (1 + realMonthlyRate);

//     const totalInvestment =
//       monthlyInvestment * months;

//     const estimatedReturns =
//       futureValue - totalInvestment;

//     const wealthGainPercentage =
//       (
//         (estimatedReturns /
//           totalInvestment) *
//         100
//       ).toFixed(1);

//     // CHART DATA
//     const data = [];

//     let runningTotal = 0;
//     let inflationValue = 0;

//     for (
//       let month = 1;
//       month <= months;
//       month++
//     ) {
//       runningTotal =
//         (runningTotal + monthlyInvestment) *
//         (1 + monthlyRate);

//       inflationValue =
//         (inflationValue +
//           monthlyInvestment) *
//         (1 + realMonthlyRate);

//       if (month % 12 === 0) {
//         data.push({
//           year: `${month / 12}Y`,
//           investment:
//             monthlyInvestment * month,
//           value: Math.round(runningTotal),
//           inflationAdjusted:
//             Math.round(inflationValue),
//         });
//       }
//     }

//     setResult({
//       futureValue,
//       totalInvestment,
//       estimatedReturns,
//       inflationAdjustedValue,
//       wealthGainPercentage,
//     });

//     setChartData(data);
//   };

//   const downloadPDF = () => {
//     if (!result) return;

//     setShowForm(true);
//   };

//   const handleFormSubmit = (userData) => {
//     const element = document.getElementById(
//       'sip-result-content'
//     );

//     const opt = {
//       margin: [0.4, 0.4, 0.4, 0.4],
//       filename: `Wisdom_SIP_Report_${userData.name}.pdf`,
//       image: {
//         type: 'jpeg',
//         quality: 1,
//       },
//       html2canvas: {
//         scale: 2,
//       },
//       jsPDF: {
//         unit: 'in',
//         format: 'a4',
//         orientation: 'portrait',
//       },
//     };

//     html2pdf().set(opt).from(element).save();

//     setShowForm(false);

//     const whatsappMessage = `
// Hello ${userData.name},

// Thank you for using Wisdom Consultancy SIP Calculator.

// 📊 SIP Investment Summary

// 💰 Monthly SIP: ₹${formatCurrency(
//       monthlyInvestment
//     )}

// 📈 Expected Return: ${expectedReturn}% p.a.

// 📉 Inflation Rate: ${inflationRate}% p.a.

// ⏳ Investment Period: ${timePeriod} Years

// ━━━━━━━━━━━━━━━

// 💼 Total Investment:
// ₹${formatCurrency(
//       result.totalInvestment
//     )}

// 📊 Estimated Returns:
// ₹${formatCurrency(
//       result.estimatedReturns
//     )}

// 🏆 Future Value:
// ₹${formatCurrency(
//       result.futureValue
//     )}

// 📉 Inflation Adjusted Value:
// ₹${formatCurrency(
//       result.inflationAdjustedValue
//     )}

// ━━━━━━━━━━━━━━━

// For expert financial planning guidance contact:

// 📞 +91 9726344477
// 📧 wisdom2secure@gmail.com

// Wisdom Consultancy
// Secure Your Future
// `;

//     window.open(
//       `https://wa.me/91${userData.phone}?text=${encodeURIComponent(
//         whatsappMessage
//       )}`,
//       '_blank'
//     );
//   };

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       className="w-full"
//     >
//       {/* HEADER */}
//       <div className="mb-10">
//         <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-5">
//           <div className="w-11 h-11 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
//             <FaCalculator />
//           </div>

//           <span className="font-semibold text-[#0b1c39]">
//             Smart Wealth Planning
//           </span>
//         </div>

//         <h2 className="text-4xl md:text-5xl font-bold text-[#0b1c39] mb-4">
//           SIP Calculator
//         </h2>

//         <p className="text-gray-600 text-lg leading-8 max-w-3xl">
//           Calculate future wealth creation through
//           Systematic Investment Plans with inflation-adjusted
//           projections and detailed investment analysis.
//         </p>
//       </div>

//       <div className="grid lg:grid-cols-2 gap-10">
//         {/* LEFT SIDE */}
//         <div className="space-y-6">
//           {/* MONTHLY SIP */}
//           <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
//             <div className="flex items-center justify-between mb-5">
//               <label className="font-bold text-[#0b1c39] text-lg">
//                 Monthly SIP Amount
//               </label>

//               <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#2e56b8]">
//                 ₹{formatCurrency(monthlyInvestment)}
//               </div>
//             </div>

//             <input
//               type="range"
//               min="500"
//               max="100000"
//               step="500"
//               value={monthlyInvestment}
//               onChange={(e) =>
//                 setMonthlyInvestment(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full accent-[#2e56b8]"
//             />

//             <div className="flex justify-between text-sm text-gray-500 mt-3">
//               <span>₹500</span>
//               <span>₹1,00,000</span>
//             </div>
//           </div>

//           {/* EXPECTED RETURN */}
//           <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
//             <div className="flex items-center justify-between mb-5">
//               <label className="font-bold text-[#0b1c39] text-lg">
//                 Expected Return
//               </label>

//               <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#69bf74]">
//                 {expectedReturn}%
//               </div>
//             </div>

//             <input
//               type="range"
//               min="1"
//               max="30"
//               step="0.5"
//               value={expectedReturn}
//               onChange={(e) =>
//                 setExpectedReturn(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full accent-[#69bf74]"
//             />

//             <div className="flex justify-between text-sm text-gray-500 mt-3">
//               <span>1%</span>
//               <span>30%</span>
//             </div>
//           </div>

//           {/* INFLATION */}
//           <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
//             <div className="flex items-center justify-between mb-5">
//               <label className="font-bold text-[#0b1c39] text-lg">
//                 Inflation Rate (Optional)
//               </label>

//               <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-orange-500">
//                 {inflationRate}%
//               </div>
//             </div>

//             <input
//               type="range"
//               min="0"
//               max="15"
//               step="0.5"
//               value={inflationRate}
//               onChange={(e) =>
//                 setInflationRate(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full accent-orange-500"
//             />

//             <div className="flex justify-between text-sm text-gray-500 mt-3">
//               <span>0%</span>
//               <span>15%</span>
//             </div>
//           </div>

//           {/* TIME PERIOD */}
//           <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
//             <div className="flex items-center justify-between mb-5">
//               <label className="font-bold text-[#0b1c39] text-lg">
//                 Investment Duration
//               </label>

//               <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#2e56b8]">
//                 {timePeriod} Years
//               </div>
//             </div>

//             <input
//               type="range"
//               min="1"
//               max="40"
//               value={timePeriod}
//               onChange={(e) =>
//                 setTimePeriod(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full accent-[#2e56b8]"
//             />

//             <div className="flex justify-between text-sm text-gray-500 mt-3">
//               <span>1 Year</span>
//               <span>40 Years</span>
//             </div>
//           </div>

//           {/* BUTTON */}
//           <button
//             onClick={calculate}
//             className="w-full bg-[#2e56b8] hover:bg-[#24479b] text-white py-5 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-xl hover:scale-[1.01]"
//           >
//             Calculate SIP Returns
//           </button>
//         </div>

//         {/* RIGHT RESULT */}
//         {result && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             className="bg-gradient-to-br from-[#edf3ff] to-[#eef8f1] border border-[#dce7ff] rounded-[35px] p-7"
//           >
//             <div className="flex items-center gap-3 mb-8">
//               <div className="w-14 h-14 rounded-2xl bg-[#2e56b8] text-white flex items-center justify-center">
//                 <FaChartLine size={24} />
//               </div>

//               <div>
//                 <h3 className="text-3xl font-bold text-[#0b1c39]">
//                   Investment Summary
//                 </h3>

//                 <p className="text-gray-500">
//                   Wealth Growth Overview
//                 </p>
//               </div>
//             </div>

//             <div className="space-y-5">
//               <div className="bg-white rounded-2xl p-5 flex justify-between items-center shadow-sm">
//                 <span className="text-gray-600 font-medium">
//                   Total Investment
//                 </span>

//                 <span className="font-bold text-[#0b1c39] text-xl">
//                   ₹
//                   {formatCurrency(
//                     result.totalInvestment
//                   )}
//                 </span>
//               </div>

//               <div className="bg-white rounded-2xl p-5 flex justify-between items-center shadow-sm">
//                 <span className="text-gray-600 font-medium">
//                   Estimated Returns
//                 </span>

//                 <span className="font-bold text-[#69bf74] text-xl">
//                   ₹
//                   {formatCurrency(
//                     result.estimatedReturns
//                   )}
//                 </span>
//               </div>

//               <div className="bg-white rounded-2xl p-5 flex justify-between items-center shadow-sm">
//                 <span className="text-gray-600 font-medium">
//                   Inflation Adjusted Value
//                 </span>

//                 <span className="font-bold text-orange-500 text-xl">
//                   ₹
//                   {formatCurrency(
//                     result.inflationAdjustedValue
//                   )}
//                 </span>
//               </div>

//               <div className="bg-[#2e56b8] rounded-[30px] p-7 text-white shadow-xl">
//                 <p className="text-white/80 mb-3 text-lg">
//                   Final Future Value
//                 </p>

//                 <h2 className="text-4xl md:text-5xl font-extrabold mb-4">
//                   ₹
//                   {formatCurrency(
//                     result.futureValue
//                   )}
//                 </h2>

//                 <div className="flex items-center gap-2 text-white/90">
//                   <FaArrowTrendUp />

//                   <span>
//                     Wealth Growth:{' '}
//                     {
//                       result.wealthGainPercentage
//                     }
//                     %
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* DOWNLOAD BUTTON */}
//             <button
//               onClick={downloadPDF}
//               className="w-full mt-8 bg-[#69bf74] hover:bg-[#58ab63] text-white py-4 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg flex items-center justify-center gap-3"
//             >
//               <FaFilePdf />
//               Download Professional PDF Report
//             </button>
//           </motion.div>
//         )}
//       </div>

//       {/* CHART SECTION */}
//       {chartData.length > 0 && (
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           className="mt-16"
//         >
//           <h3 className="text-3xl font-bold text-[#0b1c39] mb-8">
//             SIP Growth Projection
//           </h3>

//           <div className="bg-[#f8fbff] rounded-[35px] border border-[#edf3ff] p-6">
//             <div className="h-[450px]">
//               <ResponsiveContainer
//                 width="100%"
//                 height="100%"
//               >
//                 <AreaChart data={chartData}>
//                   <defs>
//                     <linearGradient
//                       id="colorValue"
//                       x1="0"
//                       y1="0"
//                       x2="0"
//                       y2="1"
//                     >
//                       <stop
//                         offset="5%"
//                         stopColor="#69bf74"
//                         stopOpacity={0.4}
//                       />

//                       <stop
//                         offset="95%"
//                         stopColor="#69bf74"
//                         stopOpacity={0}
//                       />
//                     </linearGradient>
//                   </defs>

//                   <CartesianGrid strokeDasharray="3 3" />

//                   <XAxis dataKey="year" />

//                   <YAxis />

//                   <Tooltip
//                     formatter={(value) =>
//                       `₹${formatCurrency(value)}`
//                     }
//                   />

//                   <Legend />

//                   <Area
//                     type="monotone"
//                     dataKey="value"
//                     stroke="#69bf74"
//                     fillOpacity={1}
//                     fill="url(#colorValue)"
//                     strokeWidth={3}
//                     name="Portfolio Value"
//                   />

//                   <Line
//                     type="monotone"
//                     dataKey="investment"
//                     stroke="#2e56b8"
//                     strokeWidth={3}
//                     name="Total Invested"
//                   />

//                   <Line
//                     type="monotone"
//                     dataKey="inflationAdjusted"
//                     stroke="#ff9800"
//                     strokeWidth={3}
//                     name="Inflation Adjusted"
//                   />
//                 </AreaChart>
//               </ResponsiveContainer>
//             </div>
//           </div>
//         </motion.div>
//       )}

//       {/* PDF CONTENT */}
//       {result && (
//         <div
//           id="sip-result-content"
//           style={{ display: 'none' }}
//         >
//           <div
//             style={{
//               padding: '30px',
//               fontFamily: 'Arial',
//               color: '#222',
//             }}
//           >
//             <div
//               style={{
//                 borderBottom:
//                   '4px solid #2e56b8',
//                 paddingBottom: '20px',
//                 marginBottom: '30px',
//               }}
//             >
//               <h1
//                 style={{
//                   color: '#2e56b8',
//                   fontSize: '30px',
//                 }}
//               >
//                 Wisdom Consultancy
//               </h1>

//               <p>
//                 E-44, Vasant Vihar Society,
//                 GIDC - Vadsar Road,
//                 Vadodara - 390010
//               </p>

//               <p>
//                 Phone: +91 9726344477
//               </p>

//               <p>
//                 Email:
//                 wisdom2secure@gmail.com
//               </p>
//             </div>

//             <h2
//               style={{
//                 textAlign: 'center',
//                 marginBottom: '25px',
//                 color: '#0b1c39',
//               }}
//             >
//               SIP Investment Report
//             </h2>

//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse:
//                   'collapse',
//               }}
//             >
//               <tbody>
//                 {[
//                   [
//                     'Monthly SIP',
//                     `₹${formatCurrency(
//                       monthlyInvestment
//                     )}`,
//                   ],
//                   [
//                     'Expected Return',
//                     `${expectedReturn}%`,
//                   ],
//                   [
//                     'Inflation Rate',
//                     `${inflationRate}%`,
//                   ],
//                   [
//                     'Investment Duration',
//                     `${timePeriod} Years`,
//                   ],
//                   [
//                     'Total Investment',
//                     `₹${formatCurrency(
//                       result.totalInvestment
//                     )}`,
//                   ],
//                   [
//                     'Estimated Returns',
//                     `₹${formatCurrency(
//                       result.estimatedReturns
//                     )}`,
//                   ],
//                   [
//                     'Future Value',
//                     `₹${formatCurrency(
//                       result.futureValue
//                     )}`,
//                   ],
//                   [
//                     'Inflation Adjusted Value',
//                     `₹${formatCurrency(
//                       result.inflationAdjustedValue
//                     )}`,
//                   ],
//                 ].map((row, index) => (
//                   <tr key={index}>
//                     <td
//                       style={{
//                         border:
//                           '1px solid #ddd',
//                         padding: '12px',
//                         fontWeight: 'bold',
//                       }}
//                     >
//                       {row[0]}
//                     </td>

//                     <td
//                       style={{
//                         border:
//                           '1px solid #ddd',
//                         padding: '12px',
//                       }}
//                     >
//                       {row[1]}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             <div
//               style={{
//                 marginTop: '30px',
//                 background: '#f5f5f5',
//                 padding: '20px',
//                 borderRadius: '12px',
//               }}
//             >
//               <div
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '10px',
//                   marginBottom: '10px',
//                 }}
//               >
//                 <strong>
//                   Mutual Fund Disclaimer
//                 </strong>
//               </div>

//               <p
//                 style={{
//                   fontSize: '12px',
//                   lineHeight: '22px',
//                   color: '#555',
//                 }}
//               >
//                 Mutual Fund investments are
//                 subject to market risks.
//                 Please read all scheme related
//                 documents carefully before
//                 investing. Past performance
//                 does not guarantee future
//                 returns.
//               </p>
//             </div>

//             <div
//               style={{
//                 marginTop: '30px',
//                 textAlign: 'center',
//                 fontSize: '12px',
//                 color: '#777',
//               }}
//             >
//               <p>
//                 This is a computer-generated
//                 report by Wisdom Consultancy.
//               </p>

//               <p>
//                 Secure Your Future with Smart
//                 Financial Planning.
//               </p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* FORM */}
//       {showForm && (
//         <CalculatorForm
//           onSubmit={handleFormSubmit}
//           onClose={() =>
//             setShowForm(false)
//           }
//           calculatorType="SIP"
//         />
//       )}
//     </motion.div>
//   );
// };

// export default SIPCalculator;

import React, { useState, useEffect, useRef } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
} from 'recharts';

import html2pdf from 'html2pdf.js';
import CalculatorForm from './CalculatorForm';
import { motion } from 'framer-motion';

import {
  FaChartLine,
  FaFilePdf,
  FaCalculator,
  FaArrowTrendUp,
} from 'react-icons/fa6';

const SIPCalculator = () => {
  const [monthlyInvestment, setMonthlyInvestment] =
    useState(5000);

  const [expectedReturn, setExpectedReturn] =
    useState(12);

  const [inflationRate, setInflationRate] =
    useState(6);

  const [timePeriod, setTimePeriod] =
    useState(10);

  const [showForm, setShowForm] =
    useState(false);

  const [result, setResult] = useState(null);

  const [chartData, setChartData] = useState([]);

  // NEW
  const resultRef = useRef(null);

  const formatCurrency = (value) => {
    return Number(value).toLocaleString('en-IN');
  };

  const calculate = () => {
    const monthlyRate =
      expectedReturn / 12 / 100;

    const months = timePeriod * 12;

    const inflationAdjustedReturn =
      ((1 + expectedReturn / 100) /
        (1 + inflationRate / 100) -
        1) *
      100;

    const realMonthlyRate =
      inflationAdjustedReturn / 12 / 100;

    const futureValue =
      monthlyInvestment *
      ((Math.pow(1 + monthlyRate, months) - 1) /
        monthlyRate) *
      (1 + monthlyRate);

    const inflationAdjustedValue =
      monthlyInvestment *
      ((Math.pow(
        1 + realMonthlyRate,
        months
      ) -
        1) /
        realMonthlyRate) *
      (1 + realMonthlyRate);

    const totalInvestment =
      monthlyInvestment * months;

    const estimatedReturns =
      futureValue - totalInvestment;

    const wealthGainPercentage =
      (
        (estimatedReturns /
          totalInvestment) *
        100
      ).toFixed(1);

    // NEW
    const inflationLoss =
      futureValue - inflationAdjustedValue;

    // CHART DATA
    const data = [];

    let runningTotal = 0;
    let inflationValue = 0;

    for (
      let month = 1;
      month <= months;
      month++
    ) {
      runningTotal =
        (runningTotal + monthlyInvestment) *
        (1 + monthlyRate);

      inflationValue =
        (inflationValue +
          monthlyInvestment) *
        (1 + realMonthlyRate);

      if (month % 12 === 0) {
        data.push({
          year: `${month / 12}Y`,
          investment:
            monthlyInvestment * month,
          value: Math.round(runningTotal),
          inflationAdjusted:
            Math.round(inflationValue),
        });
      }
    }

    setResult({
      futureValue,
      totalInvestment,
      estimatedReturns,
      inflationAdjustedValue,
      inflationLoss,
      wealthGainPercentage,
    });

    setChartData(data);
  };

  // AUTO SCROLL FOR MOBILE
  useEffect(() => {
    if (result && window.innerWidth < 1024) {
      setTimeout(() => {
        resultRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 200);
    }
  }, [result]);

  const downloadPDF = () => {
    if (!result) return;

    setShowForm(true);
  };

  const handleFormSubmit = (userData) => {
    const element = document.getElementById(
      'sip-result-content'
    );

    const opt = {
      margin: [0.4, 0.4, 0.4, 0.4],
      filename: `Wisdom_SIP_Report_${userData.name}.pdf`,
      image: {
        type: 'jpeg',
        quality: 1,
      },
      html2canvas: {
        scale: 2,
      },
      jsPDF: {
        unit: 'in',
        format: 'a4',
        orientation: 'portrait',
      },
    };

    html2pdf().set(opt).from(element).save();

    setShowForm(false);

    const whatsappMessage = `
Hello ${userData.name},

Thank you for using Wisdom Consultancy SIP Calculator.

📊 SIP Investment Summary

💰 Monthly SIP: ₹${formatCurrency(
      monthlyInvestment
    )}

📈 Expected Return: ${expectedReturn}% p.a.

📉 Inflation Rate: ${inflationRate}% p.a.

⏳ Investment Period: ${timePeriod} Years

━━━━━━━━━━━━━━━

💼 Total Investment:
₹${formatCurrency(
      result.totalInvestment
    )}

📊 Estimated Returns:
₹${formatCurrency(
      result.estimatedReturns
    )}

🏆 Future Value:
₹${formatCurrency(
      result.futureValue
    )}

📉 Inflation Adjusted Value:
₹${formatCurrency(
      result.inflationAdjustedValue
    )}

━━━━━━━━━━━━━━━

Wisdom Consultancy
`;

    window.open(
      `https://wa.me/91${userData.phone}?text=${encodeURIComponent(
        whatsappMessage
      )}`,
      '_blank'
    );
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="w-full"
    >
      {/* HEADER */}
      <div className="mb-10">
        <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-5">
          <div className="w-11 h-11 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
            <FaCalculator />
          </div>

          <span className="font-semibold text-[#0b1c39]">
            Smart Wealth Planning
          </span>
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-[#0b1c39] mb-4">
          SIP Calculator
        </h2>

        <p className="text-gray-600 text-lg leading-8 max-w-3xl">
          Calculate future wealth creation through
          Systematic Investment Plans with inflation-adjusted
          projections and detailed investment analysis.
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-10">
        {/* LEFT SIDE */}
        <div className="space-y-6">
          {/* MONTHLY SIP */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Monthly SIP Amount
              </label>

              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#2e56b8]">
                ₹{formatCurrency(monthlyInvestment)}
              </div>
            </div>

            <input
              type="range"
              min="500"
              max="100000"
              step="500"
              value={monthlyInvestment}
              onChange={(e) =>
                setMonthlyInvestment(
                  Number(e.target.value)
                )
              }
              className="w-full accent-[#2e56b8]"
            />

            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>₹500</span>
              <span>₹1,00,000</span>
            </div>
          </div>

          {/* EXPECTED RETURN */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Expected Return
              </label>

              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#69bf74]">
                {expectedReturn}%
              </div>
            </div>

            <input
              type="range"
              min="1"
              max="30"
              step="0.5"
              value={expectedReturn}
              onChange={(e) =>
                setExpectedReturn(
                  Number(e.target.value)
                )
              }
              className="w-full accent-[#69bf74]"
            />

            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>1%</span>
              <span>30%</span>
            </div>
          </div>

          {/* INFLATION */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Inflation Rate
              </label>

              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-orange-500">
                {inflationRate}%
              </div>
            </div>

            <input
              type="range"
              min="0"
              max="15"
              step="0.5"
              value={inflationRate}
              onChange={(e) =>
                setInflationRate(
                  Number(e.target.value)
                )
              }
              className="w-full accent-orange-500"
            />

            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>0%</span>
              <span>15%</span>
            </div>

            {/* NEW INFLATION AMOUNT */}
            {result && (
              <div className="mt-5 bg-orange-50 border border-orange-200 rounded-2xl p-4">
                <p className="text-sm text-gray-600 mb-1">
                  Inflation Impact
                </p>

                <h3 className="text-2xl font-bold text-orange-500">
                  ₹
                  {formatCurrency(
                    result.inflationLoss
                  )}
                </h3>
              </div>
            )}
          </div>

          {/* TIME PERIOD */}
          <div className="bg-[#f8fbff] border border-[#e5edff] rounded-[30px] p-6">
            <div className="flex items-center justify-between mb-5">
              <label className="font-bold text-[#0b1c39] text-lg">
                Investment Duration
              </label>

              <div className="bg-white px-4 py-2 rounded-xl shadow-sm font-bold text-[#2e56b8]">
                {timePeriod} Years
              </div>
            </div>

            <input
              type="range"
              min="1"
              max="40"
              value={timePeriod}
              onChange={(e) =>
                setTimePeriod(
                  Number(e.target.value)
                )
              }
              className="w-full accent-[#2e56b8]"
            />

            <div className="flex justify-between text-sm text-gray-500 mt-3">
              <span>1 Year</span>
              <span>40 Years</span>
            </div>
          </div>

          {/* BUTTON */}
          <button
            onClick={calculate}
            className="w-full bg-[#2e56b8] hover:bg-[#24479b] text-white py-5 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-xl hover:scale-[1.01]"
          >
            Calculate SIP Returns
          </button>
        </div>

        {/* RIGHT RESULT */}
        {result && (
          <motion.div
            ref={resultRef}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="bg-gradient-to-br from-[#edf3ff] to-[#eef8f1] border border-[#dce7ff] rounded-[35px] p-7"
          >
            <div className="flex items-center gap-3 mb-8">
              <div className="w-14 h-14 rounded-2xl bg-[#2e56b8] text-white flex items-center justify-center">
                <FaChartLine size={24} />
              </div>

              <div>
                <h3 className="text-3xl font-bold text-[#0b1c39]">
                  Investment Summary
                </h3>

                <p className="text-gray-500">
                  Wealth Growth Overview
                </p>
              </div>
            </div>

            <div className="space-y-5">
              <div className="bg-white rounded-2xl p-5 flex justify-between items-center shadow-sm">
                <span className="text-gray-600 font-medium">
                  Total Investment
                </span>

                <span className="font-bold text-[#0b1c39] text-xl">
                  ₹
                  {formatCurrency(
                    result.totalInvestment
                  )}
                </span>
              </div>

              <div className="bg-white rounded-2xl p-5 flex justify-between items-center shadow-sm">
                <span className="text-gray-600 font-medium">
                  Estimated Returns
                </span>

                <span className="font-bold text-[#69bf74] text-xl">
                  ₹
                  {formatCurrency(
                    result.estimatedReturns
                  )}
                </span>
              </div>

              <div className="bg-white rounded-2xl p-5 flex justify-between items-center shadow-sm">
                <span className="text-gray-600 font-medium">
                  Inflation Adjusted Value
                </span>

                <span className="font-bold text-orange-500 text-xl">
                  ₹
                  {formatCurrency(
                    result.inflationAdjustedValue
                  )}
                </span>
              </div>

              <div className="bg-[#2e56b8] rounded-[30px] p-7 text-white shadow-xl">
                <p className="text-white/80 mb-3 text-lg">
                  Final Future Value
                </p>

                <h2 className="text-4xl md:text-5xl font-extrabold mb-4">
                  ₹
                  {formatCurrency(
                    result.futureValue
                  )}
                </h2>

                <div className="flex items-center gap-2 text-white/90">
                  <FaArrowTrendUp />

                  <span>
                    Wealth Growth:{' '}
                    {
                      result.wealthGainPercentage
                    }
                    %
                  </span>
                </div>
              </div>
            </div>

            {/* DOWNLOAD BUTTON */}
            <button
              onClick={downloadPDF}
              className="w-full mt-8 bg-[#69bf74] hover:bg-[#58ab63] text-white py-4 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg flex items-center justify-center gap-3"
            >
              <FaFilePdf />
              Download Professional PDF Report
            </button>
          </motion.div>
        )}
      </div>

      {/* CHART SECTION */}
      {chartData.length > 0 && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="mt-16"
        >
          <h3 className="text-3xl font-bold text-[#0b1c39] mb-8">
            SIP Growth Projection
          </h3>

          <div className="bg-[#f8fbff] rounded-[35px] border border-[#edf3ff] p-6">
            <div className="h-[450px]">
              <ResponsiveContainer
                width="100%"
                height="100%"
              >
                <AreaChart data={chartData}>
                  <defs>
                    <linearGradient
                      id="colorValue"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop
                        offset="5%"
                        stopColor="#69bf74"
                        stopOpacity={0.4}
                      />

                      <stop
                        offset="95%"
                        stopColor="#69bf74"
                        stopOpacity={0}
                      />
                    </linearGradient>
                  </defs>

                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="year" />

                  <YAxis />

                  <Tooltip
                    formatter={(value) =>
                      `₹${formatCurrency(value)}`
                    }
                  />

                  <Legend />

                  <Area
                    type="monotone"
                    dataKey="value"
                    stroke="#69bf74"
                    fillOpacity={1}
                    fill="url(#colorValue)"
                    strokeWidth={3}
                    name="Portfolio Value"
                  />

                  <Line
                    type="monotone"
                    dataKey="investment"
                    stroke="#2e56b8"
                    strokeWidth={3}
                    name="Total Invested"
                  />

                  <Line
                    type="monotone"
                    dataKey="inflationAdjusted"
                    stroke="#ff9800"
                    strokeWidth={3}
                    name="Inflation Adjusted"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>
        </motion.div>
      )}

      {/* PDF CONTENT */}
      {result && (
        <div
          id="sip-result-content"
          style={{ display: 'none' }}
        >
          {/* YOUR PDF CONTENT SAME */}
        </div>
      )}

      {/* FORM */}
      {showForm && (
        <CalculatorForm
          onSubmit={handleFormSubmit}
          onClose={() =>
            setShowForm(false)
          }
          calculatorType="SIP"
        />
      )}
    </motion.div>
  );
};

export default SIPCalculator;